// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { Cota } from "../interfaces/Cota";

export const buscarCotaService = async (
  cronograma: number | undefined,
  aptoId: number | undefined,
  origemAp: number | undefined
) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        const cotas: Cota[] = response.data;
        let cotasDoUsuario: Cota[] = [];

        if (cronograma !== undefined && cronograma >= 0) {
          if (origemAp === 0) {
            //Filtrando as cotas de acordo com o apartamento registrado
            cotasDoUsuario = cotas.filter(
              (cotas: Cota) => cotas.aptoId === aptoId && cotas.origem === 0
            );
          } else {
            //Filtrando as cotas de acordo com o apartamento registrado
            cotasDoUsuario = cotas.filter(
              (cotas: Cota) => cotas.aptoId === aptoId
            );
          }
        }

        return cotasDoUsuario;

        // Retorna true se tudo correr bem e o array não estiver vazio
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
